import React from 'react'
import { connect } from 'react-redux'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { Button, Paper, Grid } from '@material-ui/core'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import Input from 'components/common/Form/Input'
import { TYPE_CONSTANT_VALUE, TYPE_LIST, TYPE_MULTIPLE } from 'helpers/logbook'
import messages from './translate'

function LogbookEventForm(props) {
  const {
    onSubmit,
    formData: { translations, type },
    intl: { formatMessage },
  } = props

  return (
    <Paper className="licensee-paper">
      <Grid container spacing={1}>
        <Grid item container xs={12} sm={12}>
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting, pristine }) => (
              <form
                onSubmit={handleSubmit}
                className="form-basic licensee-form">
                {translations.map(
                  ({
                    title,
                    locale,
                    options,
                    constant_value,
                    unit,
                    file_title,
                    comment_title,
                  }) => (
                    <Grid key={`${title}_${locale}`}>
                      <h6>{locale.toUpperCase()}</h6>
                      <Field
                        name={`${locale}[title]`}
                        type="text"
                        label={`${locale} ${formatMessage(messages.title)}`}
                        component={Input}
                        className="form-control"
                        defaultValue={title}
                        disabled={submitting}
                        required={locale === 'en'}
                        validate={
                          locale === 'en'
                            ? getValidator(VALIDATOR_IS_EMPTY)
                            : null
                        }
                      />
                      {options &&
                        (type === TYPE_LIST || type === TYPE_MULTIPLE) && (
                          <Grid>
                            <h6>{formatMessage(messages.options)}</h6>
                            {Object.keys(options).map(item => (
                              <Field
                                name={`${locale}[options[${item}]]`}
                                type="text"
                                key={`${locale}${item}`}
                                label={`${locale} ${item}`}
                                component={Input}
                                className="form-control"
                                defaultValue={options[item]}
                                disabled={submitting}
                                required={locale === 'en'}
                                validate={
                                  locale === 'en'
                                    ? getValidator(VALIDATOR_IS_EMPTY)
                                    : null
                                }
                              />
                            ))}
                          </Grid>
                        )}
                      {constant_value && type === TYPE_CONSTANT_VALUE && (
                        <Field
                          name={`${locale}[constant_value]`}
                          type="text"
                          label={`${locale} ${formatMessage(
                            messages.constantValue,
                          )}`}
                          component={Input}
                          className="form-control"
                          defaultValue={constant_value}
                          disabled={submitting}
                          required={locale === 'en'}
                          validate={
                            locale === 'en'
                              ? getValidator(VALIDATOR_IS_EMPTY)
                              : null
                          }
                        />
                      )}
                      {unit && (
                        <Field
                          name={`${locale}[unit]`}
                          type="text"
                          label={`${locale} ${formatMessage(messages.unit)}`}
                          component={Input}
                          className="form-control"
                          defaultValue={unit}
                          disabled={submitting}
                          required={locale === 'en'}
                          validate={
                            locale === 'en'
                              ? getValidator(VALIDATOR_IS_EMPTY)
                              : null
                          }
                        />
                      )}
                      {file_title && (
                        <Field
                          name={`${locale}[file_title]`}
                          type="text"
                          label={`${locale} ${formatMessage(
                            messages.fileTitle,
                          )}`}
                          component={Input}
                          className="form-control"
                          defaultValue={unit}
                          disabled={submitting}
                          required={locale === 'en'}
                          validate={
                            locale === 'en'
                              ? getValidator(VALIDATOR_IS_EMPTY)
                              : null
                          }
                        />
                      )}
                      {comment_title && (
                        <Field
                          name={`${locale}[comment_title]`}
                          type="text"
                          label={`${locale} ${formatMessage(
                            messages.commentTitle,
                          )}`}
                          component={Input}
                          className="form-control"
                          defaultValue={unit}
                          disabled={submitting}
                          required={locale === 'en'}
                          validate={
                            locale === 'en'
                              ? getValidator(VALIDATOR_IS_EMPTY)
                              : null
                          }
                        />
                      )}
                    </Grid>
                  ),
                )}
                <div className="form-group buttons">
                  <Button
                    href={null}
                    type="submit"
                    color="primary"
                    size="medium"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={submitting || pristine}>
                    {formatMessage(messages.saveInfo)}
                  </Button>
                </div>
              </form>
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default connect(
  state => ({
    loading: state.getIn(['logbookEventTranslations', 'loading']),
  }),
  {},
)(injectIntl(LogbookEventForm))
